import React from 'react'
//Please create ClsSubjectTableSvc.js and ClsSubjectFormSvc.js
const ClsSubjectSlider = () => {
    return (
        <div>ClsSubjectSlider</div>
    )
}

export default ClsSubjectSlider